import React from 'react';
import { A11ySettingsPopover } from '@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings';

import border from 'assets/svg/black-line.svg';
import logo from 'assets/svg/logo.svg';
import backButton from 'assets/svg/bw_arrow_back.svg';
import { setSessionId } from '@lwtears/lwt-common-frontend/lib/@common';
import LoginRedirect from '@lwtears/lwt-common-frontend/lib/Login';
import common from '../style/common.module.scss';
import { t } from '../../../translations';
import { useLwtStore } from '@lwtears/lwt-common-frontend/lib/LwtApp';
import { applyA11ySettings } from '@lwtears/lwt-common-frontend/lib/@common/util/a11y-util';
import { getAudioVendor } from 'utils/accessibilityUtils';

const Header = () => {
  const [
    {
      settings: {
        accessibility: {
          displaySettings: { contentScaling }
        }
      }
    }
  ] = useLwtStore();

  const goBack = () => {
    setSessionId('');
    LoginRedirect();
  };

  return (
    <div className={[common.header, common[`header${contentScaling}`]].join(' ')}>
      <div className={common.headerContent}>
        <img
          onClick={() => goBack()}
          onKeyUp={e => (e.key === 'Enter' ? goBack() : null)}
          className={[common.buttonSvg, common[`buttonSvg${contentScaling}`]].join(' ')}
          src={backButton}
          alt=""
          aria-label={t('LogOut')}
          tabIndex="0"
          role="button"
          id="backButtonHeader"
        />
        <img className={common.logo} src={logo} alt={t('LogoAltText')} />

        <div>
          <A11ySettingsPopover
            onSubmit={response => applyA11ySettings(response.data, getAudioVendor())}
          />
        </div>
      </div>
      <img className={common.border} src={border} alt="" />
    </div>
  );
};

export default Header;
